<ng-container *ngIf="menuState$ | async as menu">
    <aside class="sidebar" [class.collapsed]="isCollapsed()" [class.no-transition]="disableTransitions()">
        <div class="sidebar-header">
            <img *ngIf="!isCollapsed()" src="opscribe_logo3.png" alt="Opscribe" class="sidebar-logo">
            <button class="sidebar-toggle" (click)="toggleSidebar()">
                <i class="fa fa-bars"></i>
            </button>
        </div>

        <nav class="sidebar-nav">
            <!-- Reports -->
            <ng-container *ngIf="menu.reports">
                <a routerLink="/reports" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                    class="nav-item" title="Reports" (click)="onNavLinkClick()">
                    <i class="fa fa-file-lines"></i>
                    <span *ngIf="!isCollapsed()">Reports</span>
                </a>
            </ng-container>

            <!-- User Management (Admin Only) -->
            <ng-container *ngIf="menu.users">
                <a routerLink="/users" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                    class="nav-item" title="User Management" (click)="onNavLinkClick()">
                    <i class="fa fa-users"></i>
                    <span *ngIf="!isCollapsed()">Users</span>
                </a>
            </ng-container>

            <!-- Projects -->
            <ng-container *ngIf="menu.projects">
                <a routerLink="/reports/projects" routerLinkActive="active" class="nav-item" title="Projects"
                    (click)="onNavLinkClick()">
                    <i class="fa fa-folder"></i>
                    <span *ngIf="!isCollapsed()">Projects</span>
                </a>
            </ng-container>

            <!-- Analysis -->
            <ng-container *ngIf="menu.analysis">
                <a routerLink="/analysis" routerLinkActive="active" class="nav-item" title="Analysis"
                    (click)="onNavLinkClick()">
                    <i class="fa fa-chart-line"></i>
                    <span *ngIf="!isCollapsed()">Analysis</span>
                </a>
            </ng-container>

            <!-- Time Logs -->
            <ng-container *ngIf="menu.timelogs">
                <a routerLink="/reports/timelogs" routerLinkActive="active" class="nav-item" title="Time Logs"
                    (click)="onNavLinkClick()">
                    <i class="fa fa-clock"></i>
                    <span *ngIf="!isCollapsed()">Time Logs</span>
                </a>
            </ng-container>

            <!-- Finance Report -->
            <ng-container *ngIf="menu.financeReport">
                <a routerLink="/finance-report" routerLinkActive="active" class="nav-item" title="Finance Report"
                    (click)="onNavLinkClick()">
                    <i class="fa fa-file-invoice-dollar"></i>
                    <span *ngIf="!isCollapsed()">Finance</span>
                </a>
            </ng-container>
        </nav>

        <div class="sidebar-footer">
            <!-- Module Management (SystemAdmin Only) -->
            <ng-container *ngIf="menu.isSystemAdmin">
                <a routerLink="/users/modules" routerLinkActive="active" class="nav-item" title="Module Management"
                    (click)="onNavLinkClick()">
                    <i class="fa fa-cogs"></i>
                    <span *ngIf="!isCollapsed()">Roles</span>
                </a>
            </ng-container>

            <!-- Communication Settings (Admin Only) -->
            <ng-container *ngIf="menu.canManageSettings">
                <a routerLink="/communication-settings" routerLinkActive="active" class="nav-item"
                    title="Communication Settings" (click)="onNavLinkClick()">
                    <i class="fa fa-bell"></i>
                    <span *ngIf="!isCollapsed()">Notifications</span>
                </a>
            </ng-container>

            <!-- Profile -->
            <ng-container *ngIf="menu.profile">
                <a routerLink="/profile" routerLinkActive="active" class="nav-item" title="My Profile"
                    (click)="onNavLinkClick()">
                    <i class="fa fa-user"></i>
                    <span *ngIf="!isCollapsed()">My Profile</span>
                </a>
            </ng-container>
            <button (click)="logout()" class="btn-logout" title="Log Out">
                <i class="fa fa-right-from-bracket"></i>
                <span *ngIf="!isCollapsed()">Log Out</span>
            </button>
        </div>
    </aside>
</ng-container>